import { TypedUseSelectorHook, useSelector } from "react-redux";

import { IReduxState } from "./store/reducers.interfaces";

// Use throughout the app instead of plain `useAppDispatch` and `useAppSelector`
export const useAppSelector: TypedUseSelectorHook<IReduxState> = useSelector;
